export default __webpack_public_path__ + "static/media/crackingLeetcodeLogo.ef9463d5.png";